module.exports = __webpack_public_path__ + "img/NoPath.a101c9f4.png";